module.exports = __webpack_public_path__ + "img/biaoti_kecheng.eacf0243.png";